import { c as convert } from './convert-096451b2.js';
export default convert;